// extracted by mini-css-extract-plugin
module.exports = {"coachesSection":"CoachesPage_coachesSection__1bwEx","nav":"CoachesPage_nav__3SSHX","fadeIn":"CoachesPage_fadeIn__2lLGw"};